import { render, staticRenderFns } from "./UltimosDiarios.vue?vue&type=template&id=37b8b24b&"
import script from "./UltimosDiarios.vue?vue&type=script&lang=js&"
export * from "./UltimosDiarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports